export default __webpack_public_path__ + "assets/images/1700c078ba27970dd1da47f136ecbf03.svg";